export default {
  // Hero
  contactHeroTag: "Get In Touch",
  contactHeroTitle1: "Let's Build Something",
  contactHeroTitle2: "Together in Africa",
  contactHeroDesc: "Whether you are looking to register a company, explore investment opportunities, or need expert guidance on regulatory compliance across East Africa — our team is ready to help.",

  // Form
  formTitle: "Send Us a Message",
  formDesc: "Our team typically responds within 24 hours on business days.",
  formSuccessTitle: "Message sent successfully!",
  formSuccessBody: "Thank you for reaching out. We'll be in touch shortly.",
  formError: "Something went wrong. Please try again or email us directly.",
  formName: "Full Name",
  formEmail: "Email Address",
  formPhone: "Phone Number (with country code)",
  formSubject: "Subject",
  formCompany: "Company / Organisation",
  formMessage: "Message",
  formMessagePlaceholder: "Tell us how we can help you — the more detail, the better we can assist you.",
  formSubmit: "Send Message",
  formSending: "Sending…",
  formSelectTopic: "Select a topic…",
  subjectCompanyReg: "Company Registration",
  subjectCompliance: "Regulatory Compliance",
  subjectInvestment: "Investment Facilitation",
  subjectTender: "Tender Support",
  subjectExpansion: "Business Expansion",
  subjectGeneral: "General Inquiry",

  // Info
  infoOffice: "Our Office",
  infoPhone: "Phone",
  infoEmail: "Email",
  infoHours: "Business Hours",
  infoHoursWeekday: "Monday – Friday: 8:00 AM – 6:00 PM",
  infoHoursSaturday: "Saturday: 9:00 AM – 1:00 PM",
  infoFollowUs: "Follow Us",
  infoLine1: "KG 9 Ave, Kiyovu",
  infoLine2: "Kigali, Rwanda",
  infoEmail1: "info@africainvestmentportal.com",
  infoEmail2: "support@africainvestmentportal.com",
};